import React, { Component } from "react";
import Icon from "@material-ui/core/Icon";
import { arrowProps } from "../../../interfaces/interfaces";

import styles from "./Arrow.module.scss";

class Arrow extends Component<arrowProps> {
  constructor(props: arrowProps) {
    super(props);
  }

  render() {
    return (
      <div
        className={styles.carouselArrow}
        id={styles[this.props.direction]}
        onClick={this.props.clickFunction}
      >
        <Icon className={styles.arrow} style={{ fontSize: "1rem" }}>
          {this.props.icon}
        </Icon>
      </div>
    );
  }
}

export default Arrow;
